import { computed } from 'vue'
import { useMe } from '@/lib/api/auth/query-client'

/** `litta.applications.key` for the AI platform, used by its pages. */
export const LARA_APP = 'lara'

export function useRoles() {
    const { data, isLoading, isError } = useMe()

    const roles = computed(() => data.value?.roles ?? {})

    const rolesFor = (application: string): string[] =>
        roles.value[application] ?? []

    const hasRole = (application: string, role: string): boolean =>
        rolesFor(application).includes(role)

    return {
        hasRole,
        isError,
        isLoading,
        roles,
    }
}
